<div class="string-list-editor">
  <mat-chip-set>
    <mat-chip *ngFor="let item of items" (removed)="remove(item)" [disabled]="disabled">
      {{ item }}
      <button matChipRemove *ngIf="!disabled" type="button" [attr.aria-label]="'Remove ' + item">
        <mat-icon>cancel</mat-icon>
      </button>
    </mat-chip>
    <span *ngIf="!items.length" class="empty-hint">None</span>
  </mat-chip-set>

  <mat-form-field appearance="outline" class="add-field" *ngIf="!disabled">
    <input matInput [placeholder]="placeholder" [(ngModel)]="newValue"
           (keydown.enter)="$event.preventDefault(); add()">
    <button mat-icon-button matSuffix type="button" (click)="add()" [disabled]="!newValue.trim()"
            aria-label="Add value">
      <mat-icon>add</mat-icon>
    </button>
  </mat-form-field>
</div>
